document.addEventListener('DOMContentLoaded', initPadFinderDrawer);

function initPadFinderDrawer() {
  const openBtn = document.getElementById('find-pads-button');
  const drawer = document.getElementById('pad-finder-drawer');
  const closeBtn = document.getElementById('pad-finder-close');
  const brandSelect = document.getElementById('brand-select');
  const modelSelect = document.getElementById('model-select');
  const showBtn = document.getElementById('show-products');
  const resetBtn = document.getElementById('pad-reset');

  // --- Store the fetched data globally in this scope ---
  let allCompatibilityData = [];
  const STOREFRONT_URL = '/api/2024-04/graphql.json'; 
  const TOKEN = window.theme.pad_finder_api_token; // Verify this is your current Storefront Token
  
  /* ---------------------------
        Drawer controls (Unchanged)
  -----------------------------*/
  function openPadFinderDrawer() {
    if (!drawer) return;
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pad-finder-open'); 
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    if (brandSelect) brandSelect.focus();
  }

  function closePadFinderDrawer() {
    if (!drawer) return;
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pad-finder-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener('click', e => { e.preventDefault(); openPadFinderDrawer(); });
  if (closeBtn) closeBtn.addEventListener('click', function() {
    closePadFinderDrawer();
    if (window.pushGA4 && window.GA4_EVENTS) {
      window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.padFinder.close));
    }
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closePadFinderDrawer();
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('active')) {
      closePadFinderDrawer();
    }
  });


  /* ---------------------------
        STEP 2: Fetch Collection Details using GIDs
  -----------------------------*/
  async function fetchCollectionDetails(gids) {
    if (gids.length === 0) return {};
    
    // We create a GraphQL query fragment for each GID
    const collectionFragments = gids.map((gid, index) => `
      col${index}: node(id: "${gid}") {
        ... on Collection {
          id
          title
          handle
        }
      }
    `).join('\n');
    
    const query = `
      query GetCollections {
        ${collectionFragments}
      }
    `;

    try {
      const res = await fetch(STOREFRONT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': TOKEN,
        },
        body: JSON.stringify({ query })
      });

      const json = await res.json();
      if (json.errors) {
        console.error('GraphQL Collection Detail Errors:', json.errors);
        return {};
      }

      const collectionMap = {};
      // Map the returned collection data to a GID key for easy lookup
      Object.values(json.data).forEach(col => {
        if (col && col.id) {
          collectionMap[col.id] = { title: col.title, handle: col.handle };
        }
      });
      return collectionMap;
      
    } catch (error) {
      console.error('Collection Detail Fetch Error:', error);
      return {};
    }
  }

  /* ---------------------------
        STEP 1: Fetch all metaobjects and then enrich them
  -----------------------------*/
  async function fetchAllMetaobjects() {
    let allEntries = [];
    let gidsToFetch = []; // List to store GIDs for the second fetch
    let hasNextPage = true;
    let after = null;

    // --- First Fetch: Get Metaobject GIDs and Brand ---
    while (hasNextPage) {
      const query = `
        query {
          metaobjects(first: 250, type: "compatibility"${after ? `, after: "${after}"` : ''}) {
            nodes {
              fields {
                key
                value
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      `;
      
      try {
        const res = await fetch(STOREFRONT_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': TOKEN,
          },
          body: JSON.stringify({ query })
        });

        const json = await res.json();
        if (json.errors) {
            console.error('GraphQL Errors:', json.errors);
            hasNextPage = false;
            return allEntries; 
        }

        const nodes = json.data?.metaobjects?.nodes;
        if (!nodes) {
            hasNextPage = false;
            continue;
        }
        
        nodes.forEach(node => {
          const entry = {};
          let collectionGid = null;
          
          node.fields.forEach(f => {
            entry[f.key] = f.value;
            if (f.key === 'collection' && f.value.startsWith('gid://')) {
                collectionGid = f.value;
            }
          });

          if (entry.brand && collectionGid) {
            allEntries.push(entry);
            gidsToFetch.push(collectionGid);
          }
        });

        hasNextPage = json.data.metaobjects.pageInfo.hasNextPage;
        after = json.data.metaobjects.pageInfo.endCursor;

      } catch (error) {
          console.error('Fetch Error:', error);
          hasNextPage = false;
      }
    }
    
    // --- Second Fetch: Get Collection Titles/Handles ---
    console.log(`Phase 1 Complete. Found ${gidsToFetch.length} GIDs to resolve.`);
    // Remove duplicate GIDs for efficiency
    const uniqueGids = [...new Set(gidsToFetch)];
    const collectionDetailsMap = await fetchCollectionDetails(uniqueGids);

    // --- Merge Results ---
    const finalEntries = allEntries.map(entry => {
      const gid = entry.collection;
      const details = collectionDetailsMap[gid];
      
      if (details) {
        entry.final_handle = details.handle;
        entry.final_title = details.title;
      } else {
        // If resolution failed, leave it to be filtered out later
        entry.final_handle = null;
        entry.final_title = null;
      }
      return entry;
    });

    console.log(`Phase 2 Complete. Final resolved entries: ${finalEntries.filter(e => e.final_handle).length}/${finalEntries.length}`); 
    allCompatibilityData = finalEntries;
    return finalEntries;
  }

  /* ---------------------------
        Populate dropdowns (Logic Unchanged, relies on final_handle/title)
  -----------------------------*/
  async function populateDropdowns() {
    const data = await fetchAllMetaobjects();
    
    if (data.length === 0) {
        console.warn('Pad Finder: No compatibility metaobjects found.');
        return;
    }

    // Group entries by brand
    const grouped = {};
    data.forEach(item => {
      const brand = (item.brand || 'Unknown').trim();
      if (!grouped[brand]) grouped[brand] = [];
      grouped[brand].push(item);
    });

    // Populate brand select
    brandSelect.innerHTML = '<option value="">Select brand</option>';

    Object.keys(grouped).sort().forEach(brand => {
      const opt = document.createElement('option');
      opt.value = brand;
      opt.textContent = brand;
      brandSelect.appendChild(opt);
    });

    // Populate models dropdown when brand is selected
    brandSelect.onchange = () => {
      const selectedBrand = brandSelect.value;
      if (selectedBrand && window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.padFinder.brandSelect, { detail: 'Select Brand: ' + selectedBrand }));
      }
      const models = grouped[selectedBrand] || [];
      modelSelect.innerHTML = '<option value="">Select model</option>';
      showBtn.disabled = true; 
      
      let populatedCount = 0;

      // Sort models by the collection title (final_title)
      models.sort((a, b) => {
        const titleA = (a.final_title || a.collection || '').toLowerCase();
        const titleB = (b.final_title || b.collection || '').toLowerCase();
        return titleA.localeCompare(titleB);
      });
      
      models.forEach(m => {
        
        // **FINAL DETERMINATION OF HANDLE AND TITLE**
        const handle = m.final_handle; 
        const title = m.final_title; 
        
        // Filter out entries where the two-step fetch failed to resolve the collection details
        if (!handle || !title) {
            console.warn('❌ Filtering out entry (Handle/Title not resolved):', m); 
            return; 
        } 

        const opt = document.createElement('option');
        opt.value = handle;      // The actual collection handle
        opt.textContent = title; // The human-readable title
        modelSelect.appendChild(opt);
        populatedCount++;
      });
      
      console.log(`✅ Model Dropdown populated with ${populatedCount} valid entries for ${selectedBrand}.`);
    };
    
    // Enable/Disable Show Products button based on model selection
    modelSelect.onchange = () => {
      showBtn.disabled = !modelSelect.value;
      if (modelSelect.value && window.pushGA4 && window.GA4_EVENTS) {
        const modelText = modelSelect.options[modelSelect.selectedIndex].text;
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.padFinder.modelSelect, { detail: 'Select Model: ' + modelText }));
      }
    };

    // Show Products button → redirect to collection
    if (showBtn) {
      showBtn.onclick = e => {
        e.preventDefault();
        const handle = modelSelect.value;
        if (!handle) {
          if (!brandSelect.value) brandSelect.focus();
          else modelSelect.focus();
          return;
        }
        if (window.pushGA4 && window.GA4_EVENTS) {
          window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.padFinder.showProducts), e.target);
        }
        closePadFinderDrawer();
        window.location.href = '/collections/' + encodeURIComponent(handle);
      };
    }

    // Reset button
    if (resetBtn) {
      resetBtn.onclick = e => {
        e.preventDefault();
        if (window.pushGA4 && window.GA4_EVENTS) {
          window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.padFinder.resetSearch));
        }
        brandSelect.selectedIndex = 0;
        modelSelect.innerHTML = '<option value="">Select model</option>';
        showBtn.disabled = true;
        brandSelect.focus();
      };
    }
  }

  // Initial call to fetch data and populate the brand list
  populateDropdowns();
}
document.addEventListener("DOMContentLoaded", function(){

  const addModelBtn = document.getElementById("add-your-model");
  const addPopup = document.getElementById("add-model-popup");
  const addClose = document.getElementById("add-model-close");

  const notifyBtn = document.querySelector(".notify-btn");

  function openAddModelPopup(){
    addPopup.classList.add("active");
    addPopup.setAttribute("aria-hidden","false");
    document.body.classList.add("add-model-open");
  }

  function closeAddModelPopup(){
    addPopup.classList.remove("active");
    addPopup.setAttribute("aria-hidden","true");
    document.body.classList.remove("add-model-open");
  }

  if(addModelBtn){
    addModelBtn.addEventListener("click", function(e){
      e.preventDefault();
      if (window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.padFinder.addYourModel));
      }
      openAddModelPopup();
    });
  }

  if(addClose){
    addClose.addEventListener("click", function() {
      if (window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.addModelModal.close));
      }
      closeAddModelPopup();
    });
  }

  // Form input blur events
  var notifyBrandEl = document.getElementById("notify-brand");
  var notifyModelEl = document.getElementById("notify-model");
  var notifyEmailEl = document.getElementById("notify-email");

  if (notifyBrandEl) {
    notifyBrandEl.addEventListener("blur", function() {
      var val = this.value.trim();
      if (val && window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.addModelModal.brandInput, { detail: 'Input: Brand Name: ' + val }));
      }
    });
  }
  if (notifyModelEl) {
    notifyModelEl.addEventListener("blur", function() {
      var val = this.value.trim();
      if (val && window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.addModelModal.modelInput, { detail: 'Input: Headphone Model: ' + val }));
      }
    });
  }
  if (notifyEmailEl) {
    notifyEmailEl.addEventListener("blur", function() {
      if (this.value.trim() && window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.addModelModal.emailInput));
      }
    });
  }

  /* ------------------------------
     Notify Me Button Logic
  --------------------------------*/

  if(notifyBtn){
    notifyBtn.addEventListener("click", function(){

      const brand = document.getElementById("notify-brand").value.trim();
      const model = document.getElementById("notify-model").value.trim();
      const email = document.getElementById("notify-email").value.trim();

      if(!brand || !model || !email){
        alert("Please fill all fields");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if(!emailRegex.test(email)){
        alert("Please enter a valid email");
        return;
      }

      /* Send data to Klaviyo */
      if(window._learnq){

        _learnq.push([
          "identify",
          {
            "$email": email
          }
        ]);

        _learnq.push([
          "track",
          "Headphone Model Requested",
          {
            brand: brand,
            model: model
          }
        ]);

      }

      if (window.pushGA4 && window.GA4_EVENTS) {
        window.pushGA4(window.buildGA4Payload(window.GA4_EVENTS.addModelModal.notifySubmit));
      }

      alert("Thank you! We will notify you when available.");

      /* clear fields */
      document.getElementById("notify-brand").value = "";
      document.getElementById("notify-model").value = "";
      document.getElementById("notify-email").value = "";

      /* close popup */
      closeAddModelPopup();

    });
  }

});